<template>
  <div>
    <v-text-field
      v-if="edit"
      :class="klass"
      :label="label"
      :type="type"
      :dense="dense"
      :hide-details="true"
      :name="name"
      :reverse="true"
      placeholder="0.00"
      v-model="displayValue"
      @focus="
        type = 'number'
        displayValue = value
      "
      @blur="
        type = 'text'
        displayValue = formatDisplay(value)
      "
      width="50px"
      autocomplete="off"
      ref="currency"
      step="0.01"
    ></v-text-field>
    <div class="currency test-class" v-else>{{ formatDisplay(value) }}</div>
  </div>
</template>

<script>
export default {
  props: {
    klass: { type: String },
    name: { type: String },
    value: { type: Number, default: 0 },
    label: { type: String },
    dense: { type: Boolean, default: true },
    edit: { type: Boolean, default: true }
  },
  data: function() {
    return {
      type: "text"
    }
  },
  computed: {
    displayValue: {
      get() {
        let ref = this.$refs["currency"]
        if (ref && ref.isFocused) {
          this.type = "number"
          return this.value
        }
        this.type = "text"
        return this.formatDisplay(this.value)
      },
      set(newValue) {
        if (typeof newValue != "number") {
          let payload = parseFloat(newValue.replace("$", "").replace(",", ""))
          this.$emit("input", isNaN(payload) ? 0 : payload)
        } else {
          let payload = newValue
          this.$emit("input", isNaN(payload) ? 0 : payload)
        }
      }
    }
  },
  methods: {
    formatDisplay(input) {
      let display = parseFloat(input).toLocaleString("en-US", {
        style: "currency",
        currency: "USD"
      })
      return display
    }
  }
}
</script>
